import React from "react";
import blueCedarLogo from "../../assets/favicons/official-cedar-logo.png";

export const InvalidToken = () => {
  return (
    <div className="form_body" id="login_form_body">
      <div className="header_section">
        <img src={blueCedarLogo} alt="" />
        <span className="header_section_wordmark">CEDAR</span>
      </div>
      <form className="error_form">
        <h3>Invalid Token</h3>
        <label>It looks like you&apos;ve tried to access this page with a missing or invalid token or email.</label>
        <a href="/forgotten_password">Request another password reset token.</a>
      </form>
    </div>
  );
};
